import angular from 'angular';
import commissionSearchMatch from './commissionSearchMatch';

export default angular
  .module('commission.components.commissionSearchMatch', [])
  .component('commissionSearchMatch', commissionSearchMatch).name;
